import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DASHBOARD, } from "../../services/actions";
import {
  Typography,
  Chip,
  Container,
  Grid,
  Card,
  Box,
  Button,
  Tooltip,
  Table,
  TableHead,
  TableCell,
  TableBody,
} from "@mui/material";
import Map from "../extra/Map";

import WeatherDaily from "../extra/weather/WeatherDaily";
import logoLoader from '../extra/camera-small.png'
import StatusCard from "./StatusCard";
import CameraCard from "./CameraCard";
import InfoListCard from "./InfoListCard";
import ProjectsChart from "./Analytics";
import WeatherCard from "../extra/WeatherCard";
import VectorMap from "../extra/VectorMap";
import './dashboard.css'


const cs = {
  width: 40,
  height: "100%",
  background: "#227d52",
  borderRadius: 100,
  position: "relative",
};
const csz = {
  ...cs,
  backgroundImage:
    "repeating-linear-gradient(135deg, gray 0px, gray 2px, white 0px, white 4px)",
};

function getDays(_d, duration = 30) {
  const createdAt = new Date(_d);
  const now = new Date();

  const diffTime = now - createdAt; // milliseconds
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  //console.log(`${diffDays} days have passed`);
  //console.log(`${Math.max(0, duration - diffDays)} days left (if 30-day period)`);
  return diffDays
  //return Math.max(0, 30 - diffDays)
}

export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedProject, setSelectedProject] = useState({});
  const [loc, setLoc] = useState([]);



  const {
    dashboardState,
    imagecountState,
    projectState,

    loginState: { auth: user },
  } = useSelector((state) => state);

  const [locationName, setLocationName] = useState("West bay, Doha");


  // Add the handler for the Location Card
  const handleLocationClick = () => {
    // 1. Define the target path (must match your route definition for MapView)
    const targetPath = '/map-view'; // **Use your actual route path here**

    // 2. Use the navigate function to go to the path AND pass the state
    navigate(targetPath, {
      state: {
        // This 'markers' key must match what MapView is looking for
        markers: loc,
      },
    });
  };



  return (
    <>
      <Container maxWidth="false" sx={{ py: 4, height: '100vh', mb: 20 }}>
        <Grid container spacing={'4vmin'} mb={2}>
          <Grid item size={{ xs: 12, md: 6 }}>
            <Grid container spacing={'4vmin'} mb={2}>
              <Grid item size={{ xs: 12, sm: 12 }}>
                <Card className="card-bg" sx={{ p: 1 }}>
                  <StatusCard height={80} space={2} />
                </Card>
              </Grid>
            </Grid>
          </Grid>
          <Grid item size={{ xs: 12, md: 6 }}>
            <Card className="card-bg" sx={{ p: 1 }}>
              <Typography>Recent Tasks</Typography>
              <Table>
                <TableHead>
                  <TableCell>Task Name</TableCell>
                  <TableCell>Comments</TableCell>
                  <TableCell>Days for completion</TableCell>
                  <TableCell>view</TableCell>
                </TableHead>
                {[1, 2, 3, 4,].map((t) => <>
                  <TableBody>
                    <TableCell>Task -{t}</TableCell>
                    <TableCell>Update date</TableCell>
                    <TableCell>12 days left</TableCell>
                    <TableCell>view</TableCell>
                  </TableBody>
                </>)}
              </Table>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

